<template>
  <div class="page-history">
    <hx-trackers
      id="page-history-tracker"
      v-model="step"
      variant="vertical"
      :items="items"
      @title-button-click="onRestore"
      @subtitle-button-click="onCompare"
    />
  </div>
</template>

<script>
export default {
  name: 'PageHistoryTrackerPanel',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      step: this.modelValue
    };
  },
  methods: {
    onRestore(item, index) {
      console.log('Restore version', index, item.title);
    },
    onCompare(item, index) {
      console.log('Compare version', index, item.title);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-history {
  width: 240px;
}

// Drop the tracker's built-in horizontal padding (0 24px) and re-align the
// connector line, which is otherwise offset by that same 24px. Scoped under the
// id so it outranks the design system's 3-class selectors.
#page-history-tracker {
  :deep(.v-stepper-item) {
    padding-left: 0;
    padding-right: 8px;
  }

  :deep(.v-stepper-header .v-divider) {
    left: 12px;
  }
}
</style>
